<template>
    <div class="item-position video-item">
      <div class="video-title disable-select">
        <div>{{craneName}}</div>
        <div>{{videoTitle}}</div>
        <div><img @click="close()" style="cursor: pointer" src="/static/img/close.png" width="20"/></div>
      </div>
      <div class="video-main">
        <video
          style="outline: none"
          id='myPlayer'
          :src='addr'
          width="500"
          height="395"
          controls
          autoplay
        ></video>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Video',
  props: {
    addr: {
      type: String
    },
    videoTitle: {
      type: String
    },
    craneName: {
      type: String
    }
  },
  watch: {
    addr (val, oldVal) {
      if (val !== oldVal) {
        setTimeout(() => {
          new EZUIPlayer('myPlayer')
        }, 200)
      }
    }
  },
  methods: {
    close () {
      this.$emit('closeVideoDiv')
    }
  },
  mounted () {
    new EZUIPlayer('myPlayer')
  }
}
</script>

<style scoped lang="scss">
  .video-item{
    z-index:999;
    width:500px;
    height:435px;
    left: 1100px;
    top: 20px;
    background-color: #252525;
    /*border: 1px solid #6282b4;*/
    .video-title{
      height:35px;
      color:#ffffff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:0 10px;
    }
    .video-main{
      width:500px;
      height:400px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .disable-select {
      -moz-user-select: none;
      -webkit-user-select:none;
      -ms-user-select:none;
      user-select:none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Video.vue